import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Tracks workbook export state for global UI feedback.
 */
@Injectable({ providedIn: 'root' })
export class ExportWorkbookStatusService {
  private readonly exportingSubject = new BehaviorSubject<boolean>(false);
  readonly exporting$ = this.exportingSubject.asObservable();

  start(): void {
    this.exportingSubject.next(true);
  }

  stop(): void {
    this.exportingSubject.next(false);
  }
}
